var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4ae38fddad0cd5e0b81796a7bd12dde9fe59ffd3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prom@nicholas-gregory"]={id:"4ae38fddad0cd5e0b81796a7bd12dde9fe59ffd3"};
      